export const SET_DEMO_MODE = "SET_DEMO_MODE";
export const SET_DEMO_DATA_REQUEST = "SET_DEMO_DATA_REQUEST";
export const SET_DEMO_DATA_REQUEST_SUCCEEDED = "SET_DEMO_DATA_REQUEST_SUCCEEDED";
